// import { Rain } from './Effects/Rain';
// import { None } from './Effects/None';
// import { Snow } from './Effects/Snow';
// import { Roll } from './Effects/Roll';
import { Ash } from './Effects/Ash';
import { Particles } from './Effects/Particles';
import u from "jquery"
import anime from 'animejs';

class Effects {
  constructor() {
    this.wrapper = '#effect';
    this.effect = null;
    this.list = new Map();
    this.list.set('ash', new Ash(this.wrapper));
    this.list.set('particles', new Particles(this.wrapper));
    this.dom();

  }

  dom() {
    const buttons = u('#effect_list button');
    buttons.on('click', (e) => {
      const $this = e.currentTarget;
      if (u($this).hasClass('active')) {
        return false;
      }

      const name = u($this).data('effect');

      if(name==='ash') {
        u('#effect-bg').show();
      } else {
        u('#effect-bg').hide();
      }


      buttons.removeClass('active');
      u($this).addClass('active');
      this.run(name);
    });
  }

  run(name) {
    if(this.effect) {
      this.effect.stop();
    }
    this.startAnimation(name, 1000);
  }

  startAnimation(name, delay) {
    if (this.list.has(name)) {
      this.effect = this.list.get(name);
      this.effect.run();
      anime({
        targets: this.wrapper,
        opacity: [0, 1],
        duration: 1000,
        delay,
      });
    }
  }
}

export { Effects }
